



























































import { Component, Vue } from 'vue-property-decorator'
/* module */
import Local from '@/app/module/local'
import CommonClass from '@/app/module/common'
import { routerPath, userType } from '@/app/model/store/domain/const'

@Component
export default class HeaderUserMenu extends Vue {
  private doLogout () {
    CommonClass.doLogout()
  }
}
